import http, { endpoints } from '../http';
import { mapEstateAgentMessageFromDto, mapNoteFromDto, mapNoteHistoryFromDto } from './helpers';
const efktClient = http.createClient(endpoints.efkt);
/**
 * No booqly consumer today — ground work. Every read here is a bare array/object with no `{items,
 * total}` envelope. `UserOnly` on every route (rejects machine tokens, not a role gate), **but**
 * every write and `listEstateAgentMessages`/`postEstateAgentMessage` resolve the caller by JWT
 * `email`/`preferred_username` claim, and booqly's token carries neither
 * (`datahub/types.ts:36-43`) — verify against stage before wiring a write into a hook. The two list
 * reads below (`listForCase`/`listForOrder`) do not resolve the caller and are unaffected.
 */
export default class NotesApi {
    static async listForCase(caseId) {
        const response = await efktClient.get(`/api/case/${encodeURIComponent(caseId)}/internal-notes`);
        return response.data.map(mapNoteFromDto);
    }
    static async listForOrder(orderId) {
        const response = await efktClient.get(`/api/order/${encodeURIComponent(orderId)}/internal-notes`);
        return response.data.map(mapNoteFromDto);
    }
    /**
     * `GET /api/order-line/{orderLineId}/internal-notes`. The read side of `recordForOrderLine`, and
     * safe to wire in unlike a write here — this list route does not resolve the caller by JWT claim.
     */
    static async listForOrderLine(orderLineId) {
        const response = await efktClient.get(`/api/order-line/${encodeURIComponent(orderLineId)}/internal-notes`);
        return response.data.map(mapNoteFromDto);
    }
    static async recordForCase(caseId, body) {
        await efktClient.post(`/api/case/${encodeURIComponent(caseId)}/internal-notes`, body);
    }
    static async recordForOrder(orderId, body) {
        await efktClient.post(`/api/order/${encodeURIComponent(orderId)}/internal-notes`, body);
    }
    static async recordForOrderLine(orderLineId, body) {
        await efktClient.post(`/api/order-line/${encodeURIComponent(orderLineId)}/internal-notes`, body);
    }
    static async updateNote(noteId, body) {
        await efktClient.put(`/api/internal-notes/${encodeURIComponent(noteId)}`, body);
    }
    static async deleteNote(noteId) {
        await efktClient.delete(`/api/internal-notes/${encodeURIComponent(noteId)}`);
    }
    /** CC-scoped only per the backend's own comment — not served for other note kinds. */
    static async getNoteHistory(noteId) {
        const response = await efktClient.get(`/api/internal-notes/${encodeURIComponent(noteId)}/history`);
        return mapNoteHistoryFromDto(response.data);
    }
    static async listEstateAgentMessages(caseId) {
        const response = await efktClient.get(`/api/case/${encodeURIComponent(caseId)}/estate-agent-messages`);
        return response.data.map(mapEstateAgentMessageFromDto);
    }
    static async postEstateAgentMessage(caseId, body) {
        await efktClient.post(`/api/case/${encodeURIComponent(caseId)}/estate-agent-messages`, body);
    }
}
